import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import '../css/related-posts.css';

import placeholder from '../images/default-blog.jpg'

const RelatedPosts = ({ relatedPosts }) => {

  return (
    <div className="container blogRelatedContainer">
      <div className="grid smallGrid align-center">
        <div className="col-sm-12 maincopy">
          <h2>Related</h2>
          <hr />
        </div>
      </div>

      <div className="grid smallGrid">

        { relatedPosts &&
          relatedPosts.map(post => {
            const { id, title, excerpt, link, categories, featuredImage } = post;

            const imageData = getImage(featuredImage?.node?.localFile);

            let categoryList = '';
              if(categories && categories.nodes) {
                categoryList = categories.nodes.map((cat, index) => {
                  return index === 0 ? cat.name : ', ' + cat.name;
                }).join('');
              }


            return (
              <div key={id} className="col-sm-4">
                <div className="blogBox">
                  <a href={link} className="blogBox-link-wrapper">
                    <div className="blogBoxImage">
                      {imageData ? (
                        <GatsbyImage
                          image={imageData}
                          alt={featuredImage.node.altText || title}
                          objectFit="cover"
                          style={{ height: '100%' }}
                        />
                      ) : (
                        <img src={placeholder} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      )}
                    </div>
                    <div className="blogBoxBody">
                      <h3 className="blogBoxTitle">{title}</h3>
                      <div className="blogBoxExcerpt" dangerouslySetInnerHTML={{ __html: excerpt }}></div>
                    </div>
                    <div className="blogBoxFooter">
                      <div className="grid">
                        <div className="col-sm-7">
                          { categoryList !== '' &&
                             <p className="blogBoxCat">{categoryList}</p>
                          }
                        </div>
                        <div className="col-sm-5">
                          <span className="blogBoxLink">Read More</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            )
          })
        }

      </div>
    </div>
  )
}

export default RelatedPosts